import React from "react";
import { MimaButton, MimaText, Modal, PageLoader, ReceiptCheckBox as RCB, } from "../../components";
import { Formik } from "formik";

const ApproveAccModal = ({
    closeModal,
    onSubmit,
    loading,
    validationSchema,
    requestData,
}) => {

    return (
        <Modal closeModal={closeModal}>
            {loading ? <PageLoader loading={loading} /> : (
                <>
                    <MimaText variant="subtitle" mb={4} align="center" width={38}>
                        Approve Bank Account Creation for <b style={{ color: "var(--color-primary)" }}>{requestData.tradingName}</b> owned by <b style={{ color: "var(--color-primary)" }}>{requestData.user.firstname} {requestData.user.lastname} </b>
                    </MimaText>



                    <Formik
                        initialValues={{
                            Id: requestData._id,
                            status: "",
                        }}
                        onSubmit={onSubmit}
                        validationSchema={validationSchema}
                    >
                        {({ handleBlur,
                            handleChange,
                            setFieldValue,
                            values,
                            errors,
                            touched,
                            handleSubmit }) => (
                            <>

                                <div>
                                    <MimaText variant="small" mb={0.5}>
                                        Approve Account Request
                                    </MimaText>
                                    <div className="modal__beside">
                                        <RCB
                                            title="Yes"
                                            onChange={() => {
                                                setFieldValue('status', "APPROVED");
                                            }}
                                            checked={values.status === "APPROVED"}
                                            value="true"
                                            name="status"
                                        />
                                        <RCB
                                            title="No"
                                            checked={values.status === "REJECTED"}
                                            onChange={() =>
                                                setFieldValue('status', "REJECTED")
                                            }
                                            value="false"
                                            name="status"
                                        />
                                    </div>
                                    {errors.status ? (
                                        <div className="error">
                                            {touched.status && errors.status}
                                        </div>
                                    ) : null}
                                </div>

                                <MimaButton
                                    title="Confirm Action"
                                    type="submit"
                                    onClick={handleSubmit}
                                    width={38}
                                    loading={loading}
                                    mt={2}
                                />
                            </>
                        )}

                    </Formik>

                </>
            )}
        </Modal>
    )
}
export default ApproveAccModal;